import ReactGA from "react-ga4";

// Initialize Google Analytics
export const initGA = (GA_TRACKING_ID) => {
  ReactGA.initialize(GA_TRACKING_ID);
};

// Track page views
export const trackPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page: page });
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  ReactGA.event({
    action: action,
    category: category,
    label: label,
    value: value
  });
};

// Landing Page Events
export const trackLandingPageEvents = {
  // Hero section CTAs
  startPixelating: () =>
    trackEvent("click", "CTA", "Start Pixelating - Hero", 1),
  joinCommunity: () => trackEvent("click", "CTA", "Join Community - Hero", 1),

  // Story section
  exploreTweet: () => trackEvent("click", "Social", "Explore Elon Tweet", 1),

  // Features section
  featureHover: (featureName) =>
    trackEvent("hover", "Feature", `Feature: ${featureName}`, 1),

  // Tokenomics section
  tokenomicsView: () => trackEvent("view", "Section", "Tokenomics Section", 1),

  // Mission section
  missionView: () => trackEvent("view", "Section", "Mission Section", 1),

  // Footer CTAs
  twitterClick: () => trackEvent("click", "Social", "Twitter Footer", 1),
  telegramClick: () => trackEvent("click", "Social", "Telegram Footer", 1),

  // Final CTA
  startCreatingMemes: () =>
    trackEvent("click", "CTA", "Start Creating Memes Now", 1),

  // Header interactions
  logoClick: () => trackEvent("click", "Navigation", "Logo Click", 1),
  followClick: () => trackEvent("click", "Social", "Follow Button Header", 1)
};

// App Page Events
export const trackAppEvents = {
  // Image input methods
  imageUrlSubmit: (url) =>
    trackEvent("input", "Image Upload", "Image URL Submit", 1),
  imageFileUpload: (fileType) =>
    trackEvent("upload", "Image Upload", `File Upload: ${fileType}`, 1),
  imageDragDrop: () => trackEvent("upload", "Image Upload", "Drag and Drop", 1),

  // Pixelation controls
  pixelWidthChange: (width) =>
    trackEvent("adjust", "Pixelation", `Pixel Width: ${width}`, width),
  autoWidthClick: (width) =>
    trackEvent("click", "Pixelation", `Auto Width: ${width}`, width),
  pixelateClick: () => trackEvent("click", "Pixelation", "Pixelate Button", 1),

  // Image processing
  imageProcessed: (originalSize, pixelWidth) =>
    trackEvent(
      "process",
      "Image",
      `Processed: ${originalSize}px -> ${pixelWidth}px`,
      1
    ),
  imageDownload: () =>
    trackEvent("download", "Image", "Download Pixelated Image", 1),

  // Error tracking
  imageError: (errorType) =>
    trackEvent("error", "Image", `Error: ${errorType}`, 1),
  fetchError: (errorMessage) =>
    trackEvent("error", "Network", `Fetch Error: ${errorMessage}`, 1),

  // User interactions
  controlsHover: () => trackEvent("hover", "UI", "Controls Panel", 1),
  imageAreaHover: () => trackEvent("hover", "UI", "Image Display Area", 1),

  // App navigation
  appLoad: () => trackEvent("view", "Page", "App Page Load", 1),
  appUnload: () => trackEvent("leave", "Page", "App Page Leave", 1)
};

// Utility functions for common tracking patterns
export const trackCTAClick = (ctaName, location) => {
  trackEvent("click", "CTA", `${ctaName} - ${location}`, 1);
};

export const trackFormInteraction = (formName, fieldName, action) => {
  trackEvent(action, "Form", `${formName} - ${fieldName}`, 1);
};

export const trackUserEngagement = (engagementType, details) => {
  trackEvent("engagement", "User", `${engagementType}: ${details}`, 1);
};

// Track conversion events
export const trackConversion = (conversionType, value) => {
  trackEvent("conversion", "Business", conversionType, value);
};

// Track performance metrics
export const trackPerformance = (metric, value) => {
  trackEvent("performance", "Technical", metric, value);
};
